import React from 'react';
import { motion } from 'framer-motion';

export const Features: React.FC = () => {
  return (
    <section className="py-8 mt-16 relative">
      <div className="container mx-auto px-2">
        <div className="relative rounded-[50px] overflow-hidden py-12">
          {/* Background Image */}
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: 'url(/Images/featureS_bg.webp)' }}
          />
      
      <div className="px-4 text-center relative z-50">

        <h2 
          className="text-3xl md:text-5xl font-heading font-bold mb-12 leading-tight"
          style={{
            fontFamily: 'Nanum Myeongjo',
            color: '#620131'
          }}
        >
          Good packaging{' '}
          <motion.img 
            src="/Images/f_one.webp" 
            alt="Package 1" 
            className="inline-block w-8 h-8 md:w-16 md:h-16 object-contain mx-1 md:mx-2 transform -rotate-3"
            animate={{ 
              y: [0, -10, 0],
              rotate: [-3, 2, -3]
            }}
            transition={{ 
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
          {' '}feels premium.{' '}
          <motion.img 
            src="/Images/f_two.webp" 
            alt="Package 2" 
            className="inline-block w-8 h-8 md:w-16 md:h-16 object-contain mx-1 md:mx-2 transform rotate-3"
            animate={{ 
              y: [0, -12, 0],
              rotate: [3, -2, 3]
            }}
            transition={{ 
              duration: 3.5,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 0.5
            }}
          />
          <br className="hidden md:block" />
          Great packaging feels{' '}
          <span className="inline-block transform -rotate-3 bg-secondary/10 px-2 rounded mt-2 md:mt-0">
            effortless.
          </span>
          {' '}
          <motion.img 
            src="/Images/f_three.webp" 
            alt="Package 3" 
            className="inline-block w-8 h-8 md:w-16 md:h-16 object-contain mx-1 md:mx-2"
            animate={{ 
              y: [0, -8, 0],
              rotate: [0, 5, 0]
            }}
            transition={{ 
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 1
            }}
          />
        </h2>

        {/* Product Showcase */}
        <div className="relative max-w-4xl mx-auto mt-16">
          
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative z-10"
          >
             {/* Placeholder for the Product Image - Hidden to allow floating box to take its place */}
             <div className="opacity-0 w-64 md:w-80 mx-auto aspect-[3/5] bg-gradient-to-br from-orange-400 to-pink-500 rounded-lg shadow-2xl transform rotate-12 flex flex-col items-center justify-center text-white p-6">
                <h3 className="text-2xl font-heading font-bold mb-1">PRINTAURA</h3>
                <p className="text-xs opacity-90 mb-6">Cosmetics</p>
                <div className="text-center mt-auto mb-12">
                  <p className="text-lg font-bold leading-tight">Desmaquillante</p>
                  <p className="text-[10px] opacity-80">Fortalecedor de pestañas y cejas</p>
                </div>
             </div>
          </motion.div>
        </div>
        
        {/* Large PrintAura Text at Bottom */}
        <div className="absolute -bottom-16 left-1/2 -translate-x-1/2 w-full text-center pointer-events-none select-none overflow-hidden">
          <h2 
            style={{
              fontFamily: 'Nanum Myeongjo',
              fontWeight: 800,
              fontSize: 'clamp(80px, 20vw, 303.41px)',
              lineHeight: '335.39px',
              letterSpacing: '0%',
              background: 'linear-gradient(180deg, #FF309D 34.49%, rgba(153, 29, 94, 0) 71.55%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              opacity: 0.3
            }}
          >
            PrintAura
          </h2>
        </div>
        </div>
      </div>
      </div>
    </section>
  );
};
